import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import _OuterContainer from "UserTaggingPingBodyStyles-OuterContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=OuterContainer";
import _ContentContainer from "UserTaggingPingBodyStyles-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=ContentContainer";
import _CueContainer from "UserTaggingPingBodyStyles-CueContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=CueContainer";
import _ExclamationIcon from "UserTaggingPingBodyStyles-ExclamationIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=ExclamationIcon";
import _CueTextContainer from "UserTaggingPingBodyStyles-CueTextContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=CueTextContainer";
import _QuestionContainer from "UserTaggingPingBodyStyles-QuestionContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=QuestionContainer";
import _QuestionProgress from "UserTaggingPingBodyStyles-QuestionProgress.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=QuestionProgress";
import _ButtonContainer from "UserTaggingPingBodyStyles-ButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=ButtonContainer";
import _CompletedBox from "UserTaggingPingBodyStyles-CompletedBox.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=CompletedBox";
import _CompletedCheckmark from "UserTaggingPingBodyStyles-CompletedCheckmark.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/user_tagging/styles/UserTaggingPingBodyStyles.tsx?styleId=CompletedCheckmark";


// astroturf styles:
export const OuterContainer = /*#__PURE__*/styled("div", null, {
  displayName: "OuterContainer",
  styles: _OuterContainer
});

export const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

export const CueContainer = /*#__PURE__*/styled("div", null, {
  displayName: "CueContainer",
  styles: _CueContainer
});

export const ExclamationIcon = /*#__PURE__*/styled(Icon, null, {
  displayName: "ExclamationIcon",
  styles: _ExclamationIcon
});

export const CueTextContainer = /*#__PURE__*/styled("div", null, {
  displayName: "CueTextContainer",
  styles: _CueTextContainer
});

export const QuestionContainer = /*#__PURE__*/styled("div", null, {
  displayName: "QuestionContainer",
  styles: _QuestionContainer
});

export const QuestionProgress = /*#__PURE__*/styled("div", null, {
  displayName: "QuestionProgress",
  styles: _QuestionProgress
});

export const ButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
});

export const CompletedBox = /*#__PURE__*/styled("div", null, {
  displayName: "CompletedBox",
  styles: _CompletedBox
});

export const CompletedCheckmark = /*#__PURE__*/styled(Icon, null, {
  displayName: "CompletedCheckmark",
  styles: _CompletedCheckmark
});
